import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const INITIAL_REVIEWS_TO_SHOW = 3;

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;
  const [showAllReviews, setShowAllReviews] = useState(false);
  const noReviews = !reviews || reviews.length === 0;

  const hasMoreReviews = reviews && reviews.length > INITIAL_REVIEWS_TO_SHOW;
  const displayedReviews = showAllReviews || !hasMoreReviews
    ? reviews
    : reviews.slice(0, INITIAL_REVIEWS_TO_SHOW);

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      {noReviews && !fetchReviewsError && (
        <p className={css.noReviewsText}>Es gibt noch keine Bewertungen.</p>
      )}
      <Reviews reviews={displayedReviews} />
      {hasMoreReviews && !showAllReviews && (
        <button
          className={css.showMoreReviewsButton}
          onClick={() => setShowAllReviews(true)}
        >
          <FormattedMessage
            id="ListingPage.showMoreReviews"
            values={{ count: reviews.length - INITIAL_REVIEWS_TO_SHOW }}
          />
        </button>
      )}
    </section>
  );
};

export default SectionReviews;
